import * as core from '../../../../../../../core'

import { query } from './degree-of-change-bar-chart.query'

export const RESOURCE = {
  payload: {
    alias: 'degree.of.change.bar.chart',
    description: 'Bar chart of change impacts by degree of change',
    name: 'Degree of Change Bar Chart',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
